import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetItemController::__invoke
* @see app/Http/Controllers/Screen/GetItemController.php
* @route '/api/screen/data/get-item'
*/
const GetItemController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetItemController.url(options),
    method: 'post',
})

GetItemController.definition = {
    methods: ["post"],
    url: '/api/screen/data/get-item',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Screen\GetItemController::__invoke
* @see app/Http/Controllers/Screen/GetItemController.php
* @route '/api/screen/data/get-item'
*/
GetItemController.url = (options?: RouteQueryOptions) => {
    return GetItemController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetItemController::__invoke
* @see app/Http/Controllers/Screen/GetItemController.php
* @route '/api/screen/data/get-item'
*/
GetItemController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetItemController.url(options),
    method: 'post',
})

export default GetItemController